/**
 * Inspired by:
 * https://github.com/vercel/examples/tree/main/edge-middleware/ab-testing-google-optimize
 * */
import type { Experiment } from 'helpers/optimize/optimize.types';
import {
  AB_COOKIE,
  CONTROL_COOKIE,
  COOKIE_NAME,
  ONE_DAY_IN_SECONDS,
  THREE_MONTHS_IN_SECONDS,
} from 'helpers/optimize/constants';
import Cookies from 'universal-cookie';

import experiment from 'helpers/optimize/optimize_experiment.json';
import getConfig from 'next/config';

const {
  publicRuntimeConfig: { AB_RUNNING },
} = getConfig();

export function getCurrentExperiment() {
  return experiment as Experiment;
}

export function isExperimentRunning() {
  const isRunning = AB_RUNNING && AB_RUNNING === 'true' ? true : false;
  return isRunning;
}

export function isInTheExperiment(cookies?: Cookies) {
  const a = isExperimentRunning();
  const b = getVariant(cookies) === AB_COOKIE.KEYCLOAK;
  return a && b;
}

export const getWeights = (): number[] | null => {
  const WEIGHTS = process.env.AB_WEIGHTS || '["0","100"]';
  if (WEIGHTS) {
    try {
      const parsedWeights = JSON.parse(WEIGHTS);
      if (Array.isArray(parsedWeights)) {
        const weights = parsedWeights.map((weight) => parseInt(weight));
        return weights;
      } else return null;
    } catch (error) {
      // It might be in the format "[100 0]" which won't parse
      if (typeof process.env.AB_WEIGHTS === 'string') {
        // trim the [] and split by spaces
        const parsedWeights = process.env.AB_WEIGHTS.substring(
          1,
          process.env.AB_WEIGHTS.length - 1,
        ).split(' ');
        if (Array.isArray(parsedWeights)) {
          return parsedWeights.map((a) => parseInt(a));
        } else return null;
      } else {
        return null;
      }
    }
  } else return null;
};

/**
 * For client side use only
 * @returns if experiment is control variant or not
 */
export const isControl = (cookies?: Cookies) => {
  if (typeof cookies === 'undefined') {
    cookies = new Cookies();
  }
  const abCookie = cookies.get(COOKIE_NAME);
  if (!abCookie) return true; // safety fallback
  return Boolean(abCookie === CONTROL_COOKIE);
};

/**
 * For client side use only
 * @returns the cookie variant as a number
 */
export const getVariant = (cookies?: Cookies) => {
  if (typeof cookies === 'undefined') {
    cookies = new Cookies();
  }
  const abCookie = cookies.get(COOKIE_NAME);
  if (abCookie) return parseInt(abCookie);
  else return 0;
};

export const getMaxAge = (cookie: string) => {
  switch (parseInt(cookie)) {
    case AB_COOKIE.LEGACY:
      return ONE_DAY_IN_SECONDS;
    case AB_COOKIE.KEYCLOAK:
      return THREE_MONTHS_IN_SECONDS;
    default:
      return ONE_DAY_IN_SECONDS;
  }
};
